(() => {
  const initHeader = () => {
    const header = document.querySelector('.cc-header-wrapper[data-cc-transparent="true"]');
    if (!header) return;

    const update = () => {
      header.classList.toggle('cc-header--solid', window.scrollY > 24);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader, { once: true });
  } else {
    initHeader();
  }
})();
